<template>
    <van-collapse v-model="activate">
        <template v-if="data">
        <van-collapse-item title="评估">
            <van-cell title="评估依据:"  :value="data.estimateSource" />
            <van-cell title="评估总价:" >{{data.estimatePrice}}万元</van-cell>
            <van-cell title="抵押率:" >
                {{ mortgageRate|mortgageRateConvert }}
            </van-cell>
        </van-collapse-item>
        <van-collapse-item title="转贷信息">
            <van-cell title="借款用途:"><br><div v-html="data.loanPurpose"></div></van-cell>
            <van-cell title="还款来源:"><br><div v-html="data.repaySource"></div></van-cell>
        </van-collapse-item>
        <van-collapse-item title="买家信息" v-if="itemType=='TRADE'">
            <van-cell title="买家:"  :value="data.buyer" />
            <van-cell title="成交中介:"  :value="data.medium" />
            <van-cell title="网签价格:"  :value="data.signPrice" />
            <van-cell title="回款来源:"  :value="data.backSource" />
            <van-cell title="当前进度:"  :value="data.process" />
        </van-collapse-item>
        <van-collapse-item title="借款人资质">
            <van-cell title="借款人资质:"><br><div v-html="data.qualified"></div></van-cell>
        </van-collapse-item>
        <van-collapse-item title="流程监控">
            <van-cell title="放款条件:"><br><div v-html="data.loanCondition"></div></van-cell>
            <van-cell title="过程控制要求:"><br><div v-html="data.processController"></div></van-cell>
            <van-cell title="增加担保措施:"><br><div v-html="data.guarantee"></div></van-cell>
            <van-cell title="综合意见:"><br><div v-html="data.remark"></div></van-cell>
        </van-collapse-item>
        </template>
        <van-collapse-item title="初审附件">
        <div style="text-align: center">
            <oss-investigation
                    tabType="5"
                    pictureType="2"
                    :applyId="applyId" />
        </div>
        </van-collapse-item>

    </van-collapse>
</template>

<script>
    import {ImagePreview} from 'vant'
    import {getForeClousureFileList} from '@/api/loanInfo'
    import {getFormData} from '@/api/foreclosure'
    import { getForeclosureApplyInfo } from '@/api/loanInfo'
    import OssInvestigation from '@/views/component/oss-investigation'
    export default {
        name: 'risk-final-approval',
        props: {
            applyId: {
                type: String,
                default: ''
            },
            itemType:{
                type: String,
                default: ''
            }
        },
        components: {
            OssInvestigation
        },
        data() {
            return {
                activate: [],
                images: [],
                data:null,
                mortgageRate:''
            }
        },
        mounted() {
            //this.initData()
            this.loadData()
            this.loadMortgageRate()
        },
        filters:{
            mortgageRateConvert(value){
                if(value==''||value==null||typeof (value)=='undefined'){
                    return ''
                }else{
                    return value+'%'
                }
            }
        },
        methods: {
            loadData() {
                const self = this
                let params = {
                    applyId: this.applyId,
                    formModule: 'F_RiskFinal'
                }
                getFormData(params).then(res => {
                    if (res.success) {
                        let data={}
                        res.data!=null&&res.data.forEach((item,index)=>{
                            data[item.ext]=item.info
                        })
                        self.data=data
                    }
                })
            },
            initData() {
                this.images = []
                this.getFileList("5")
            },
            getFileList(tabType){
                let params = {
                    applyId: this.applyId,
                    pictureType: '2',
                    tabType: tabType
                }
                getForeClousureFileList(params).then(res => {
                    if (res.success) {
                        this.images = this.images.concat(res.data)
                    }
                })
            },
            loadMortgageRate(){
                let self=this
                getForeclosureApplyInfo({applyId: self.applyId}).then(res => {
                    if (res.success) {
                        self.mortgageRate = res.applyInfo.mortgageRate||''
                    }
                })
            },
            showImage(data, position) {
                let imgs = []
                data.forEach(item => {
                    if(item.fileFormat == '1'){
                        imgs.push(item.pictureRsUrl)
                    }
                })
                const instance = ImagePreview({
                    images: imgs,
                    lazyLoad: true,
                    startPosition: typeof position === 'number' ? position : 0
                })
            }
        }
    }
</script>

<style scoped>

</style>
